import getDisplayName from '@lib/utils/getDisplayName';
import useService from '@modules/ServiceModule/useService';
import usePhoneState from '@modules/SoftPhoneModule/usePhoneState';
import { ITask, TaskState } from '@modules/TasksModule/types';

const useVoiceTask = (task?: ITask) => {
  const { userByContactCenterUserId } = useService();
  const { callList } = usePhoneState();

  if (!task) {
    return {
      isAccepted: false,
      isHeld: false,
      isOffered: false,
      isMissed: false,
      isWrapUp: false,
      isInternal: false,
      isInbound: false,
      displayName: '',
      isConnecting: false,
      isAnswering: false,
      isSelfTransfer: false,
    };
  }

  const call = callList.find((call) => call.callId === task.attributes?.callId);

  const hasCallId = task.attributes?.callId;
  const isTaskAccepted = task.state === TaskState.Accepted;
  const callExists = !!call;
  const isPrimary = callExists && call.primary;
  const isCallHeld = callExists && call.held;
  const isConnecting = !!task.attributes?.isConnecting;
  const isIncomingTransfer = !!task.attributes?.conversationDetails?.isTransfer;
  const escalationSummary = task.attributes?.escalationSummary as
    | string
    | undefined;
  const transferStatus = task.attributes?.transferStatus;
  const isSelfTransfer = !!task.attributes?.isSelfTransfer;

  // Determine if the call is held based on the conditions
  const isHeld = hasCallId
    ? isTaskAccepted && callExists && (!isPrimary || isCallHeld)
    : false;

  const isAccepted = task.state === TaskState.Accepted;
  const isOffered = task.state === TaskState.Offered;
  const isMissed =
    task.state === TaskState.Abandoned || task.state === TaskState.TimedOut;
  const isWrapUp = task.state === TaskState.WrapUp;
  const isInbound = task.direction === 'inbound';
  const isInternal =
    task.type === 'voice-internal-queue' ||
    task.type === 'voice-internal-did' ||
    call?.internalCall;
  const isExternal = task.attributes?.shouldClassify;

  const isAnswering = !!task.attributes?.isAnswering;
  const displayName = getDisplayName(
    task.displayName ?? task.from,
    userByContactCenterUserId,
  );

  return {
    isAccepted,
    isHeld,
    isOffered,
    isMissed,
    isWrapUp,
    isInternal,
    isInbound,
    isConnecting,
    displayName,
    isExternal,
    isAnswering,
    isIncomingTransfer,
    escalationSummary,
    transferStatus,
    isSelfTransfer,
  };
};

export default useVoiceTask;
